module.exports = __webpack_public_path__ + "img/pic8.be426513.jpg";